import { render, staticRenderFns } from "./Gynecology.vue?vue&type=template&id=13b28d12&scoped=true"
import script from "./Gynecology.vue?vue&type=script&lang=js"
export * from "./Gynecology.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b28d12",
  null
  
)

export default component.exports